import { useCallback } from "react";
import { ValidateElectronicsResult } from "../models/validateElectronicsResult.ts";
import { ElectronicsConfiguration } from "../models/electronicsConfiguration.ts";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useValidateElectronics = () => {
  const { handle, setError } = useMessageHandler();

  const validateElectronics = useCallback(async (
    payload: ElectronicsConfiguration, 
  ): Promise<ValidateElectronicsResult | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/electronics/validate", payload);
      if ((response.data as ValidateElectronicsResult).result === false) {
        setError((response.data as ValidateElectronicsResult).description);
      }
      return response.data as ValidateElectronicsResult;
    }).catch(() => null);
  }, [handle]);

  return { validateElectronics, setError };
};
